export const MuiFormControlLabel = {
  styleOverrides: {
    root: {
      margin: '0',
      fontFamily: 'Sarabun',

      '.MuiCheckbox-root': {
        marginRight: '11px',
        marginTop: '2px',
        alignSelf: 'flex-start',
      },

      '.MuiTypography-root': {
        fontSize: '14px',
        lineHeight: '18.2px',
      },

      '.MuiRadio-root + .MuiFormControlLabel-label': {
        marginLeft: '8px',
      },
    },
  },
};
